import React, {
  FC, useState, useEffect,
} from 'react';
import { Slide } from '@mui/material';
import { RefreshLabel } from './styles';
import { JobTab } from '../../../state/jobStatus';

interface IProps {
  onQueryJobs: (value: boolean) => void,
  jobTab: JobTab,
  liveEventsDateFilter?: Date,
}

const JobListRefreshTimer: FC<IProps> = (props: IProps) => {
  const { onQueryJobs, jobTab, liveEventsDateFilter } = props;
  const [lastUpdated, setLastUpdated] = useState<string | null>(null);
  const [currentJobTab, setCurrentJobTab] = useState<JobTab>(jobTab);
  const [liveEventsDate, setLiveEventsDate] = useState<Date | null>(liveEventsDateFilter);

  useEffect(() => {
    const queryJobs = () => {
      setLastUpdated(new Date().toLocaleTimeString());
      onQueryJobs(true);
    };

    if (liveEventsDate !== liveEventsDateFilter) {
      setLiveEventsDate(liveEventsDateFilter);
      if (jobTab === JobTab.LiveEvents || jobTab === JobTab.ExchangeEvents) queryJobs();
    }
    if (currentJobTab !== jobTab) {
      setCurrentJobTab(jobTab);
      queryJobs();
    }

    if (!lastUpdated) queryJobs(); // Get jobs immediately once
    const interval = setInterval(queryJobs, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [onQueryJobs, jobTab, liveEventsDateFilter]);

  return (
    <Slide direction="left" in={!!lastUpdated} data-refresh-timer="JobListRefreshTimer">
      <RefreshLabel className="Job-List-Refresh-Timer">
        Last Updated: {lastUpdated || ''}
      </RefreshLabel>
    </Slide>
  );
};

export default JobListRefreshTimer;
